
    const data = {"name":"src/core/icons/circle-small","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M12 10a2 2 0 0 0-2 2 2 2 0 0 0 2 2c1.11 0 2-.89 2-2a2 2 0 0 0-2-2Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            